import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { WELCOME_GUIDE_LINKS, SUPPORT_EMAIL } from '../constants';

const guideItems = [
  { text: 'Cómo completar mi formulario de registro (nuevos proveedores)', url: WELCOME_GUIDE_LINKS.REGISTRATION_FORM },
  { text: 'Checklist de Documentos', url: WELCOME_GUIDE_LINKS.DOCUMENTS_CHECKLIST },
  { text: 'Cómo actualizar los contactos de mi compañía', url: WELCOME_GUIDE_LINKS.UPDATE_CONTACTS },
  { text: 'Cómo responder a una petición de cambio', url: WELCOME_GUIDE_LINKS.ANSWER_CHANGE_REQUEST },
  { text: 'Cómo actualizar información general de mi compañía (Nombre, dirección, etc.)', url: WELCOME_GUIDE_LINKS.UPDATE_GENERAL_INFO },
  { text: 'Cómo actualizar sus datos bancarios', url: WELCOME_GUIDE_LINKS.UPDATE_BANK_DATA },
];

export const WelcomeDialog = ({ open, onClose, onOpenTaxProfiles }) => {
  return (
    <Dialog maxWidth="md" fullWidth onClose={onClose} open={open}>
      <DialogTitle>Estimado Proveedor</DialogTitle>
      <DialogContent dividers>
        <Typography paragraph>
          El mantenimiento actualizado de su documentación es un requisito indispensable
          para el procesamiento de sus facturas y pagos.
        </Typography>

        <Typography paragraph sx={{ fontWeight: 'bold' }}>
          Guía para mantener perfil actualizado:
        </Typography>

        <List dense sx={{ listStyleType: 'disc', pl: 4 }}>
          {guideItems.map((item) => (
            <ListItem key={item.text} sx={{ display: 'list-item', pl: 0, py: 0.25 }}>
              <ListItemText
                primary={
                  <span>
                    {item.text}{' '}
                    <Link href={item.url} target="_blank" rel="noopener noreferrer" sx={{ color: '#1976d2', textDecorationColor: '#1976d2' }}>
                      [Link]
                    </Link>
                  </span>
                }
              />
            </ListItem>
          ))}
          <ListItem sx={{ display: 'list-item', pl: 0, py: 0.25 }}>
            <ListItemText
              primary={
                <span>
                  Legajo Impositivos Sociedades TEIC{' '}
                  <Link
                    component="button"
                    type="button"
                    onClick={onOpenTaxProfiles}
                    sx={{ color: '#1976d2', textDecorationColor: '#1976d2', verticalAlign: 'baseline' }}
                  >
                    [Link]
                  </Link>
                </span>
              }
            />
          </ListItem>
        </List>

        <Typography paragraph sx={{ mt: 2 }}>
          Si necesita asistencia en este proceso, no dude en contactar a nuestro Call Center
          al número telefónico correspondiente a su país (
          <Link href={WELCOME_GUIDE_LINKS.COUNTRY_CALL_CENTERS} target="_blank" rel="noopener noreferrer" sx={{ color: '#1976d2', textDecorationColor: '#1976d2' }}>
            encuéntrelos aquí
          </Link>
          ), o bien enviar una solicitud de soporte a{' '}
          <Box component="span" sx={{ fontWeight: 'bold', color: 'text.primary' }}>{SUPPORT_EMAIL}</Box>{' '}
          indicando el nombre de su compañía, país y número de identificación fiscal.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="contained" onClick={onClose}>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
